import { Component, OnDestroy, OnInit } from '@angular/core';
import { PrintService } from 'src/app/core/services/print.service';
import { Case } from 'src/app/shared/models/cases/case';

interface tableCol {
  prop: string;
  name: string;
  format: string;
}
@Component({
  selector: 'app-print-files-report',
  templateUrl: './print-files-report.component.html',
  styleUrls: ['./print-files-report.component.scss']
})
export class PrintFilesReportComponent implements OnInit, OnDestroy {
  reportTitle: string | null = null;
  cases: Case[] = [];
  columns: tableCol[] = [];
  landscapeStyleTag: HTMLElement = document.createElement('style');


  constructor(
    private printService: PrintService,
  ) {
    this.cases = this.printService.data?.cases;
    this.columns = this.printService.data?.columns;
    this.reportTitle = this.printService.data?.reportTitle;
  }
  ngOnDestroy(): void {
    document.head.removeChild(this.landscapeStyleTag);
  }

  ngOnInit(): void {
    this.injectLandscapeOrentation();
    this.printService.onDataReady('Files');
  }

  injectLandscapeOrentation() {
    let css = '@page { size: landscape; }';
    this.landscapeStyleTag.appendChild(document.createTextNode(css));
    document.head.appendChild(this.landscapeStyleTag);
  }

}
